export default {
  SET_CLIENTE(state, cliente) {
    state.cliente = cliente
  },
  SET_EQUIPO(state, equipo) {
    state.equipo = equipo
  },
  SET_BOLETA(state, boleta) {
    state.boleta = boleta
  },
  SET_FECHA_COMPRA_EQUIPO(state, fecha) {
    state.fechaCompraEquipo = fecha
  },
  // extension = producto elegido en el paso 3, o null si "No necesito extensión".
  SET_EXTENSION(state, extension) {
    state.extension = extension
  },
  // protecciones = array de productos elegidos en el paso 4 (0-2).
  SET_PROTECCIONES(state, protecciones) {
    state.protecciones = protecciones || []
  },
  // OVG03.2 — Cupón de descuento (SILL-1523)
  SET_CUPON(state, cupon) {
    state.cupon = cupon
  },
  SET_CUPON_LOADING(state, loading) {
    state.cuponLoading = loading
  },
  SET_CUPON_ERROR(state, error) {
    state.cuponError = error
  },
  RESET_STATE(state) {
    state.cliente = null
    state.equipo = null
    state.boleta = null
    state.fechaCompraEquipo = null
    state.extension = null
    state.protecciones = []
    state.cupon = null
    state.cuponLoading = false
    state.cuponError = null
  },
}
